/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorWorkspaceDto } from '../../models/vendor-workspace-dto';

export interface VendorWorkspaceControllerDelete$Params {
  id: string;
}

export function vendorWorkspaceControllerDelete(http: HttpClient, rootUrl: string, params: VendorWorkspaceControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceDto>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorWorkspaceDto>;
    })
  );
}

vendorWorkspaceControllerDelete.PATH = '/api/vendorWorkspace/{id}';
